import { useLocation } from 'react-router-dom';
import { PretailorTopbar } from './pre-tailoring.topbar/pre-tailoring.topbar.component';
import { TailorTopbar } from './tailoring.topbar/tailoring.topbar.component';

export interface TopbarProps extends React.HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  onToProducts?: () => void;
  onNext?: () => void;
  onBack?: () => void;
}

export const Topbar = ({ onNext: handleNext, onToProducts: handleOnToProducts, ...props }: TopbarProps) => {
  const location = useLocation();
  const isPretailoring = location.pathname.includes('pre-tailoring');
  return (
    <>
      {isPretailoring && <PretailorTopbar onNext={handleNext} onToProducts={handleOnToProducts} {...props} />}
      {!isPretailoring && <TailorTopbar onNext={handleNext} onToProducts={handleOnToProducts} {...props} />}
    </>
  );
};
